import { Edit } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import { api as axios } from '../api';
import React, { useEffect, useState } from 'react';
import url from '../serverUrl';
import { logoWrapper } from '../utils';
import Switch from '@mui/material/Switch';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import TreasuryLockStatusFields from './editForms/TreasuryLockStatusFields';

function EditToken({ token, setOpen, open, tokenType }) {
  const [updatedToken, setUpdatedToken] = useState(token);
  const [logo, setLogo] = useState(updatedToken?.logo);
  const [checked, setChecked] = useState(token?.status);
  useEffect(() => {
    setUpdatedToken(token);
    setLogo(token.logo);
  }, [token]);

  const handleClose = () => {
    setOpen(false);
  };

  const saveToken = () => {
    // const bodyData = {
    //   id: updatedToken.id,
    //   name: updatedToken.name,
    //   description: updatedToken.description,
    //   link: updatedToken.link,
    //   type: updatedToken.type,
    //   logo: updatedToken.logo,
    //   currentPrice: updatedToken.currentPrice,
    //   status: checked,
    //   sort: updatedToken.sort,
    //   symbol: updatedToken.symbol,
    //   volume: updatedToken.volume
    // };
    const bodyData = {
      id: updatedToken.id,
      symbol: updatedToken.symbol,
      name: updatedToken.name,
      description: updatedToken.description,
      issuer: updatedToken.issuer,
      currency: updatedToken.currency,
      face_value: updatedToken.face_value,
      dcn_amount: updatedToken.dcn_amount,
      annual_yield: updatedToken.annual_yield,
      yield_redemption_code: updatedToken.yield_redemption_code,
      conversion_type_code: updatedToken.conversion_type_code,
      ytm_type_code: updatedToken.ytm_type_code,
      maturity_date: updatedToken.maturity_date,
      early_redemption: updatedToken.early_redemption,
      mandatory_hold: updatedToken.mandatory_hold,
      seniority: updatedToken.seniority,
      logo: updatedToken.logo,
      status: checked,
      // tokenType is passed in explicitly by token.table.js's dispatch for
      // types (like EQUITRACK) whose row has no `type` column of its own -
      // updatedToken.type is always undefined for those, which is why Save
      // silently hit the backend's "not supported yet" fallback.
      type: tokenType || updatedToken.type
    };

    axios
      .put(`${url}/crypto/updateToken`, bodyData)
      .then((res) => {
        alert(JSON.stringify(res.data));
      })
      .catch((err) => {
        alert(JSON.stringify(err));
      });
  };
  // Only wired for EquiTrack right now (the one type this form got an
  // explicit tokenType prop for - see token.table.js's dispatch). Hard
  // delete: removes the row and clears its treasury links, but leaves any
  // existing wallet holdings under its identitySymbol untouched - same
  // tradeoff as everywhere else in this app that doesn't hard-delete
  // balances.
  const deleteToken = () => {
    if (tokenType !== 'EQUITRACK') return;
    if (
      !window.confirm(
        `Delete ${updatedToken?.name || updatedToken?.symbol}? This cannot be undone.`
      )
    ) {
      return;
    }

    axios
      .delete(`${url}/crypto/delete_equitrack_token/${updatedToken.id}`)
      .then((res) => {
        alert(res.data?.message || 'Deleted');
        if (res.data?.status) setOpen(false);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || err.message);
      });
  };
  const saveFileDerivatives = (e) => {
    const formData = new FormData();
    const pic = e.target.files[0];
    setLogo(URL.createObjectURL(pic));
    formData.append('image', e.target.files[0]);
    formData.append('fileName', e.target.files[0].name);
    axios.post(`${url}/hootdex/token-logo-upload`, formData).then((res) => {
      if (res.data.status === 'ok') {
        setUpdatedToken({
          ...updatedToken,
          logo: `${url}/hootdex/images/${res.data.fileName}`
        });
      }
    });
  };

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    setUpdatedToken({ ...updatedToken, [name]: value });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          width: '100%'
        }
      }}
      maxWidth="md"
      sx={{ zIndex: 2002 }}
    >
      <div
        style={{
          backgroundColor: 'whitesmoke',
          padding: '5rem'
        }}
      >
        <div style={{ position: 'relative' }}>
          <img src={logoWrapper(logo, token)} width={150} alt={token?.name} />
          <input
            id="fileInput"
            className="input"
            onChange={saveFileDerivatives}
            type="file"
            placeholder="Enter"
            hidden={true}
          ></input>

          <label
            for="fileInput"
            style={{
              position: 'absolute',
              bottom: '20px',
              cursor: 'pointer'
            }}
          >
            <Edit />
          </label>
        </div>
        <p>
          Status {checked ? 'Active' : 'Inactive'}:
          <Switch
            checked={checked}
            onChange={(event) => setChecked(event.target.checked)}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </p>
        <input
          className="input"
          name={'name'}
          value={updatedToken.name}
          label="Edit"
          onChange={handleChange}
        />
        <input
          className="input"
          name={'symbol'}
          value={updatedToken.symbol}
          onChange={handleChange}
        />
        {(token.type === 'PDCN' || token.type === 'FDCN') && (
          <>
            <TextField
              fullWidth
              label="Issuer"
              margin="normal"
              value={updatedToken.issuer ?? ''}
              onChange={(e) =>
                setUpdatedToken({ ...updatedToken, issuer: e.target.value })
              }
            />

            <TextField
              fullWidth
              label="Currency"
              margin="normal"
              value={updatedToken.currency ?? 'USD'}
              onChange={(e) =>
                setUpdatedToken({ ...updatedToken, currency: e.target.value })
              }
            />

            <TextField
              fullWidth
              type="number"
              label="Face Value"
              margin="normal"
              value={updatedToken.face_value ?? ''}
              onChange={(e) =>
                setUpdatedToken({ ...updatedToken, face_value: e.target.value })
              }
            />

            <TextField
              fullWidth
              type="number"
              label="DCN Amount"
              margin="normal"
              value={updatedToken.dcn_amount ?? ''}
              onChange={(e) =>
                setUpdatedToken({ ...updatedToken, dcn_amount: e.target.value })
              }
            />

            <TextField
              fullWidth
              label="Seniority"
              margin="normal"
              value={updatedToken.seniority ?? 'Senior Secured'}
              onChange={(e) =>
                setUpdatedToken({ ...updatedToken, seniority: e.target.value })
              }
            />

            <TextField
              fullWidth
              type="number"
              label="Annual Yield (%)"
              margin="normal"
              value={updatedToken.annual_yield ?? ''}
              onChange={(e) =>
                setUpdatedToken({
                  ...updatedToken,
                  annual_yield: e.target.value
                })
              }
            />

            {/* Yield Redemption */}
            <FormControl fullWidth margin="normal">
              <InputLabel id="yield-redemption-label">
                Yield Redemption
              </InputLabel>
              <Select
                labelId="yield-redemption-label"
                label="Yield Redemption"
                value={updatedToken.yield_redemption_code ?? ''}
                onChange={(e) =>
                  setUpdatedToken({
                    ...updatedToken,
                    yield_redemption_code: e.target.value
                  })
                }
                MenuProps={{ disablePortal: true }}
              >
                <MenuItem value="930101">Monthly</MenuItem>
                <MenuItem value="930102">Quarterly</MenuItem>
                <MenuItem value="930103">Semi-Annual</MenuItem>
                <MenuItem value="930104">Annual</MenuItem>
              </Select>
            </FormControl>

            {/* Conversion Window */}
            <FormControl fullWidth margin="normal">
              <InputLabel id="conversion-window-label">
                Conversion Window
              </InputLabel>
              <Select
                labelId="conversion-window-label"
                label="Conversion Window"
                value={updatedToken.conversion_type_code ?? ''}
                onChange={(e) =>
                  setUpdatedToken({
                    ...updatedToken,
                    conversion_type_code: e.target.value
                  })
                }
                MenuProps={{ disablePortal: true }}
              >
                <MenuItem value="990101">6 Months</MenuItem>
                <MenuItem value="990102">12 Months</MenuItem>
                <MenuItem value="990103">18 Months</MenuItem>
                <MenuItem value="990104">24 Months</MenuItem>
                <MenuItem value="990105">30 Months</MenuItem>
                <MenuItem value="990106">36 Months</MenuItem>
              </Select>
            </FormControl>

            {/* YTM Type */}
            <FormControl fullWidth margin="normal">
              <InputLabel id="ytm-type-label">YTM Type</InputLabel>
              <Select
                labelId="ytm-type-label"
                label="YTM Type"
                value={updatedToken.ytm_type_code ?? ''}
                onChange={(e) =>
                  setUpdatedToken({
                    ...updatedToken,
                    ytm_type_code: e.target.value
                  })
                }
                MenuProps={{ disablePortal: true }}
              >
                <MenuItem value="980101">Standard YTM</MenuItem>
                <MenuItem value="980303">Worst Case YTM</MenuItem>
                <MenuItem value="980302">Put Adjusted YTM</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              type="date"
              label="Maturity Date"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={updatedToken.maturity_date ?? ''}
              onChange={(e) =>
                setUpdatedToken({
                  ...updatedToken,
                  maturity_date: e.target.value
                })
              }
            />

            <TextField
              fullWidth
              type="date"
              label="Early Redemption Date"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={updatedToken.early_redemption ?? ''}
              onChange={(e) =>
                setUpdatedToken({
                  ...updatedToken,
                  early_redemption: e.target.value
                })
              }
            />

            <TextField
              fullWidth
              type="date"
              label="Mandatory Hold Date"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={updatedToken.mandatory_hold ?? ''}
              onChange={(e) =>
                setUpdatedToken({
                  ...updatedToken,
                  mandatory_hold: e.target.value
                })
              }
            />
          </>
        )}

        {token.type === 'STNTHETICS' && (
          <input
            className="input"
            name={'volume'}
            value={updatedToken.volume}
            onChange={handleChange}
          />
        )}
        <input
          className="input"
          name={'identitySymbol'}
          value={updatedToken.identitySymbol}
          disabled
        />
        <input
          className="input"
          name={'link'}
          value={updatedToken.link}
          onChange={handleChange}
          placeholder="link"
        />

        {token.type === 'hedge' && (
          <input
            className="input"
            name={'currentPrice'}
            value={updatedToken.currentPrice}
            onChange={handleChange}
            placeholder="currentPrice"
          />
        )}

        <TreasuryLockStatusFields
          tokenType={tokenType || token.type}
          tokenId={updatedToken?.id}
        />
        <textarea
          className="input"
          style={{ height: '200px' }}
          name={'description'}
          value={updatedToken.description}
          onChange={handleChange}
        />
        <input
          className="input"
          name={'sort'}
          value={updatedToken.sort}
          onChange={handleChange}
          placeholder="sort"
        />
        <button
          style={{
            backgroundColor: 'darkgreen',
            width: '300px',
            padding: '1rem',
            color: 'white',
            margin: '2rem',
            cursor: 'pointer'
          }}
          onClick={() => {
            saveToken();
          }}
        >
          Save
        </button>
        {tokenType === 'EQUITRACK' && (
          <button
            style={{
              backgroundColor: 'darkred',
              width: '300px',
              padding: '1rem',
              color: 'white',
              margin: '2rem',
              cursor: 'pointer'
            }}
            onClick={() => {
              deleteToken();
            }}
          >
            Delete
          </button>
        )}
      </div>
    </Dialog>
  );
}

export default EditToken;
